import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';

import { ApplicationBootstrap } from './modules/core/app/application-bootstrap';
import { LazyApplication } from './modules/core/app/lazy-application';
import { createGlobalServices } from './modules/core/global-services';

import './styles/index.css';

function renderApplication() {
  const services = createGlobalServices({ backendUrl: '/' });

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        networkMode: 'always',
        refetchOnWindowFocus: false
      }
    }
  });

  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <>
      <ApplicationBootstrap services={services} queryClient={queryClient}>
        <Suspense fallback={null}>
          <LazyApplication />
        </Suspense>
      </ApplicationBootstrap>
      <ToastContainer style={{ width: 'min(365px, calc(100vw - 2rem))' }} />
    </>
  );
}

function startApp() {
 renderApplication();
}

(async () => {
  if (import.meta.env.VITE_APP_MOCKED === 'true') {
    console.log('Loading MSW...');
    void import('./mocks/browser')
      .then(({ worker }) => worker.start())
      .then(startApp);
  } else {
    void startApp();
  }
})();
